<template>
  <div>
    <div style="background-color: #55555511">
      <el-image style="width:45%;height: 120px;" fit="contain"
                :src="require('../assets/title.png')"></el-image>
    </div>
    <div class="navDivCss" ref="mainDiv">
      <el-menu unique-opened style="width: 85%"
               :default-active="index"
               mode="horizontal" background-color="#5866aa" text-color="#fff" active-text-color="#ffd04b">
        <el-menu-item key="home" :style="{minWidth:itemWidth+'px',textAlign:'center'}"
                      :index="homeIndex"
                      @click.native="clickMenu(homeIndex,'home')"
        >首页
        </el-menu-item>
        <template v-for="item in navColumns">
          <el-submenu @click.native="clickMenu(item.id,'main',null)"
                      v-if="item.subColumn&&item.subColumn.length>0" :index="item.id"
                      :key="item.id" :style="{minWidth:itemWidth+'px',textAlign:'center'}">
            <template slot="title">
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item v-for="column in item.subColumn" style="text-align: center"
                          :index="column.id" :key="column.id"
                          @click.native="clickMenu(column.id,'sub',item.id)">
              {{ column.name }}
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else @click.native="clickMenu(item.id,'main',null)" :index="item.id"
                        :key="item.id" :style="{minWidth:itemWidth+'px',textAlign:'center'}">{{ item.name }}
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import {getNavColumn} from "../api/column";

export default {
  name: "myHeader",
  data() {
    return {
      homeIndex: '00000000-0000-0000-0000-000000000000',
      index: '00000000-0000-0000-0000-000000000000',
      //导航栏数据
      navColumns: [],
      itemWidth: 0
    };
  },
  mounted() {
    getNavColumn().then(res => {
      //请求成功，返回res
      this.navColumns = res.columns
      let n = this.navColumns.length
      let width = this.$refs.mainDiv.clientWidth * 0.85
      this.itemWidth = Math.floor(width / n) - 23
    }).catch(err => {
      //请求失败
      console.log(err)
    })
  },
  methods: {
    clickMenu: function (id, type, pid) {
      if (type == 'main') {
        this.$router.push({path: '/general', query: {id: id}});
      } else if (type == 'sub') {
        this.$router.push({path: '/content', query: {pid: pid, sid: id}});
      } else {
        this.$router.push({path: '/'});
      }
    }
  }
}
</script>

<style scoped>

.navDivCss {
  background-color: #5866aa;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  float: left;
}

</style>
